import { Component, OnInit, Input } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de message alert
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
    selector: 'app-message-alert',
    templateUrl: './message-alert.component.html',
    styleUrls: ['./message-alert.component.scss']
})
export class MessageAlertComponent extends BaseComponent implements OnInit {

    @Input("type") typeAlert: string = 'info';

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

}
